import { render, staticRenderFns } from "./newTransScanOut_v2.vue?vue&type=template&id=2775ad2c&scoped=true&"
import script from "./newTransScanOut_v2.vue?vue&type=script&lang=js&"
export * from "./newTransScanOut_v2.vue?vue&type=script&lang=js&"
import style0 from "./newTransScanOut_v2.vue?vue&type=style&index=0&id=2775ad2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2775ad2c",
  null
  
)

component.options.__file = "newTransScanOut_v2.vue"
export default component.exports